import { Dropdown, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';

import {
  createLanguageMenuItems,
  getCurrentLocaleFlag,
  handleLocaleChange,
} from './sidebar-utils';

interface LanguageSwitcherProps {
  isCollapsed: boolean;
  placement?: 'topRight' | 'bottomRight';
}

/**
 * Language Switcher Component
 * Dropdown to switch between English and Spanish
 */
export function LanguageSwitcher({
  isCollapsed,
  placement = 'topRight',
}: LanguageSwitcherProps) {
  const { t, i18n } = useTranslation();
  const locale = i18n.language;

  const languageMenuItems = createLanguageMenuItems(handleLocaleChange);
  const currentLocaleFlag = getCurrentLocaleFlag(locale);

  return (
    <Tooltip
      title={t('navigation.changeLanguage')}
      placement={isCollapsed ? 'right' : undefined}
    >
      <Dropdown
        menu={{ items: languageMenuItems, selectedKeys: [locale] }}
        trigger={['click']}
        placement={placement}
      >
        <button className="inline-flex cursor-pointer justify-center rounded p-2 text-gray-500 hover:bg-gray-100 hover:text-gray-900 dark:hover:bg-gray-700 dark:hover:text-white">
          <span className="text-2xl">{currentLocaleFlag}</span>
        </button>
      </Dropdown>
    </Tooltip>
  );
}
